import { put, all, select } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import selectors from "rdx/modules/settings/selectors";
import messages from "rdx/modules/settings/messages";
import { keysToCamelCase } from "lib/helpers";

function* updateAdminServiceArea(action) {
  const { success, data, error } = yield* makeRequest.put(`/service_areas/${action.payload.state}`, action.payload);

  if (success && data) {
    let out;
    if (data.body.service_areas) {
      out = data.body.service_areas.map((s) => keysToCamelCase(s));
    } else {
      out = yield select(selectors.getAdminServiceAreas);
    }
    yield all([
      put(actions.setAdminServiceAreas(out)),
      put(
        actions.newSuccessEvent({
          message: messages.SERVICE_AREA_UPDATE_SUCCESS,
        }),
      ),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_UPDATING_SERVICE_AREA,
    });
  }

  return null;
}

export default updateAdminServiceArea;
